import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=4a3cde2a&"
import script from "./EditProducts.vue?vue&type=script&lang=js&"
export * from "./EditProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports